import { useCreateAppointmentNotificationMutation } from "../../../api/appointments/useCreateAppointmentNotificationMutation";
import { uiNotification } from "../../../services/UINotificationService";

export function useCreateAppointmentNotification() {
  const languageData = JSON.parse(localStorage.getItem("languageData"));

  const { mutateAsync, isLoading } = useCreateAppointmentNotificationMutation({
    onSuccess: () => {
      uiNotification.success("Notification sent successfully");
    },
    onError: (error) => {
      uiNotification.error(
        languageData.global[error.response?.data?.message] ||
          error.response?.data?.message,
      );
    },
  });

  return {
    createAppointmentNotification: mutateAsync,
    isAppointmentNotificationCreating: isLoading,
  };
}
